import React, { Component } from 'react'
import {
    FormControl,
    FormControlLabel,
    Checkbox,
    Select,
    MenuItem,
} from '@mui/material'

class DisplayItemUserSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fast_switch:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.fast_switch
                    : null,
            default_current_user:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.default_current_user
                    ? this.props.item.settings.default_current_user
                    : null,
            display_name_style:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.display_name_style
                    ? this.props.item.settings.display_name_style
                    : null,
        }
    }

    render() {
        const kedo = this.props.kedo

        return (
            <FormControl fullWidth margin="normal">
                <FormControlLabel
                    control={
                        <Checkbox
                            size="small"
                            checked={this.state.fast_switch === true}
                            onChange={(e) => {
                                this.setState({ fast_switch: e.target.checked })
                                this.props.onChange(
                                    'fast_switch',
                                    e.target.checked
                                )
                            }}
                            name="fast_switch"
                            disabled={this.props.disabled}
                        />
                    }
                    label={this.props.kedo.t('Fast switch')}
                    sx={{
                        mb: 0,
                        '& .MuiFormControlLabel-label': {
                            fontSize: '0.875rem',
                            color: 'text.primary',
                        },
                    }}
                />

                <FormControlLabel
                    control={
                        <Checkbox
                            size="small"
                            checked={this.state.default_current_user === true}
                            onChange={(e) => {
                                this.setState({
                                    default_current_user: e.target.checked,
                                })
                                this.props.onChange(
                                    'default_current_user',
                                    e.target.checked
                                )
                            }}
                            name="default_current_user"
                            disabled={this.props.disabled}
                        />
                    }
                    label={this.props.kedo.t('Current user as default')}
                    sx={{
                        mb: 0,
                        '& .MuiFormControlLabel-label': {
                            fontSize: '0.875rem',
                            color: 'text.primary',
                        },
                    }}
                />
                <Select
                    displayEmpty
                    size="small"
                    id={'display_name_style'}
                    value={this.state.display_name_style || ''}
                    disabled={this.props.disabled}
                    onChange={(e) => {
                        this.setState({ display_name_style: e.target.value })
                        this.props.onChange(
                            'display_name_style',
                            e.target.value
                        )
                    }}
                >
                    <MenuItem value="default">Default</MenuItem>
                    <MenuItem value="avatar">Avatar</MenuItem>
                    <MenuItem value="both">Both</MenuItem>
                </Select>
            </FormControl>
        )
    }
}

export default DisplayItemUserSettings
